



















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { DropdownOption } from '@/models/swine/dropdown.model';
import { ADD_COMPARISONS_DATA } from '@/utils/constants';
import { generateUniqueId } from '@/utils/lodash';

@Component({})
export default class SplitDropdown extends Vue {
  isActive = false;
  selected: DropdownOption | null = null;

  @Prop({
    type: Boolean,
    default: false,
  })
  disabled!: boolean;

  @Prop({
    type: Array,
    default: [],
    required: true,
  })
  options!: DropdownOption[];

  @Prop({
    type: String,
    default: `#8e8e8e`,
  })
  borderColor!: string;

  get borderColorTheme() {
    return `color: ${this.borderColor};`;
  }

  @Emit('select')
  handleSelected(data: DropdownOption) {
    this.isActive = !this.isActive;
    return data;
  }

  created() {
    this.initializeDefaultOption();
  }

  initializeDefaultOption() {
    this.selected = {
      text: `Add Comparison`,
      value: `farm_unit`,
      uniqueKey: generateUniqueId(`add_comparison_`),
    };
  }

  @Emit('select')
  spawnFarmUnitSelection() {
    // Return the first value which is the
    const index = ADD_COMPARISONS_DATA.findIndex((item) => {
      return item.value === 'farm_unit';
    });
    return ADD_COMPARISONS_DATA[index];
  }
}
